import {onVisible} from "../../../scripts/Tools/visible-element-observer";
import {getPhoneInfo} from "../../../webpack/modules-optimized/contact";

onVisible(document.querySelectorAll(".fire-footer-events"), async function () {
    let view = await getPhoneInfo();
    if (view) document.getElementById('show-contact-info').innerHTML = view;
}, 0.1);